module.exports = {
	"width": "100%",
	"height": "100%",
	"flashVars": {
		"context": "site",
		"site": "as",
		"profile": "1"
	},
	"embed": {
		"containerSwf": "http://cvp1.cdn.turner.com/xslo/cvp/assets/container/2.5.7.1/cvp_main_container.swf",
		"expressInstallSwf": "http://cvp1.cdn.turner.com/xslo/cvp/assets/flash/expressInstall.swf",
		"options": {
			"quality": "high",
			"bgcolor": "#000000",
			"allowFullScreen": "true",
			"allowScriptAccess": "always",
			"wmode": "opaque"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/common/config/cvp.json
// module id = 176
// module chunks = 1 2